// tslint:disable
if (!global.Promise) {
    global.Promise = require('core-js/library/es6/promise');
}

if (!Element.prototype.matches) {
    Element.prototype.matches =
        (Element as any).prototype.matchesSelector ||
        (Element as any).prototype.mozMatchesSelector ||
        (Element as any).prototype.msMatchesSelector ||
        (Element as any).prototype.oMatchesSelector ||
        (Element as any).prototype.webkitMatchesSelector ||
        function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) { }
            return i > -1;
        };
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/browser/polyfill.tsx